import * as Sentry from '@sentry/react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRouter, ErrorComponent, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { routeTree } from './routeTree.gen';
import './index.css';
import './i18n';

const queryClient = new QueryClient();

const router = createRouter({
  routeTree,
  defaultErrorComponent: () => <Sentry.ErrorBoundary fallback={ErrorComponent} />,
  defaultOnCatch: Sentry.reactErrorHandler(),
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://ab5d22ee75d93c2718c89a98950f34bf@o4510167347429376.ingest.us.sentry.io/4510167359946752',

    sendDefaultPii: true,

    integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],

    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^\//],
    tunnel: '/api/tunnel',
  });
}

const rootElement = document.getElementById('root');
if (rootElement && !rootElement.innerHTML) {
  const root = createRoot(rootElement);
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </StrictMode>,
  );
}
